import { render, staticRenderFns } from "./vod.vue?vue&type=template&id=a8658e78&scoped=true&"
import script from "./vod.vue?vue&type=script&lang=js&"
export * from "./vod.vue?vue&type=script&lang=js&"
import style0 from "./vod.vue?vue&type=style&index=0&id=a8658e78&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8658e78",
  null
  
)

export default component.exports